export default {
	site_name: 'veradata',
};
